import React from 'react';

import './style.sass';
import FullWrapper from '../../layouts-components__common-cases/full-wrapper';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonTitle from '../../../common-components/common-title';
import CommonSmallText from '../../../common-components/common-small-text';

const Process = () => {
    return (
        <ScrollAnimation animateIn="fadeIn" offset={50} animateOnce={true} duration={1}>
            <FullWrapper className="krdv-process" smallPaddings={true}>
                <div className="krdv-process__wrapper">
                    <CommonTitle className="krdv-process__title">Процесс</CommonTitle>
                    <CommonSmallText className="krdv-process__text-info">
                        В&nbsp;рамках имеющегося сайта мы&nbsp;расширили функционал, который был
                        необходим пользователям для получения услуг или взаимодействия друг
                        с&nbsp;другом в&nbsp;маркетплейсе. Чтобы одни находили инвесторов, другие
                        при помощи рекламы организовывали коллабораци, третьи с&nbsp;умом
                        инвестировали свой капитал и&nbsp;решали проблемы технических условий.
                    </CommonSmallText>
                </div>
            </FullWrapper>
        </ScrollAnimation>
    );
};

export default Process;
